import React from 'react';
import AmplienceHeaderNav, { AmplienceHeaderNavProps } from 'components/amplience/header-nav';

export interface Props {
  headerNav: AmplienceHeaderNavProps;
}

const HeaderNavigationDesktop: React.FC<Props> = ({ headerNav }) => {
  return <AmplienceHeaderNav megaNavs={headerNav?.megaNavs} />;
};

export default HeaderNavigationDesktop;
